export default {
      id: "published_date-usage",
      viewBox: "0 0 14 15",
      url: __webpack_public_path__ + "sprite.svg#published_date",
      toString: function () {
        return this.url;
      }
    }